export enum OrderMeasuresTypes {
    QUANTITY = 'quantity',
    WEIGHT = 'weight',
    VOLUME = 'volume',
    MONEY = 'money',
    PALLET = 'pallet',
    PACK = 'pack',
}
